'use client';

import { useState, useEffect } from 'react';
import HeroSection from './HeroSection';
import ShippingCalculator from './ShippingCalculator';
import TrackingSearch from './TrackingSearch';
import ServicesSection from './ServicesSection';
import TestimonialsSection from './TestimonialsSection';
import TrustSection from './TrustSection';
import CTASection from './CTASection';

const HomepageInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [showCalculator, setShowCalculator] = useState(false);
  const [showTracking, setShowTracking] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleCalculatorOpen = () => {
    setShowCalculator(true);
  };

  const handleCalculatorClose = () => {
    setShowCalculator(false);
  };

  const handleTrackingOpen = () => {
    setShowTracking(true);
  };

  const handleTrackingClose = () => {
    setShowTracking(false);
  };

  if (!isHydrated) {
    return (
      <div data-component-id="src/app/homepage/components/HomepageInteractive.tsx:39:6" data-component-path="src/app/homepage/components/HomepageInteractive.tsx" data-component-line="39" data-component-end-line="41" data-component-file="HomepageInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22min-h-screen%22%7D" className="min-h-screen">
        <div data-component-id="src/app/homepage/components/HomepageInteractive.tsx:40:8" data-component-path="src/app/homepage/components/HomepageInteractive.tsx" data-component-line="40" data-component-end-line="40" data-component-file="HomepageInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-screen%20bg-primary%20animate-pulse%22%7D" className="h-screen bg-primary animate-pulse"></div>
      </div>
    );
  }

  return (
    <>
      <HeroSection data-component-id="src/app/homepage/components/HomepageInteractive.tsx:47:6" data-component-path="src/app/homepage/components/HomepageInteractive.tsx" data-component-line="47" data-component-end-line="50" data-component-file="HomepageInteractive.tsx" data-component-name="HeroSection" data-component-content="%7B%22elementName%22%3A%22HeroSection%22%7D"
        onCalculatorClick={handleCalculatorOpen}
        onTrackingClick={handleTrackingOpen}
      />
      <ServicesSection data-component-id="src/app/homepage/components/HomepageInteractive.tsx:51:6" data-component-path="src/app/homepage/components/HomepageInteractive.tsx" data-component-line="51" data-component-end-line="51" data-component-file="HomepageInteractive.tsx" data-component-name="ServicesSection" data-component-content="%7B%22elementName%22%3A%22ServicesSection%22%7D" />
      <TestimonialsSection data-component-id="src/app/homepage/components/HomepageInteractive.tsx:52:6" data-component-path="src/app/homepage/components/HomepageInteractive.tsx" data-component-line="52" data-component-end-line="52" data-component-file="HomepageInteractive.tsx" data-component-name="TestimonialsSection" data-component-content="%7B%22elementName%22%3A%22TestimonialsSection%22%7D" />
      <TrustSection data-component-id="src/app/homepage/components/HomepageInteractive.tsx:53:6" data-component-path="src/app/homepage/components/HomepageInteractive.tsx" data-component-line="53" data-component-end-line="53" data-component-file="HomepageInteractive.tsx" data-component-name="TrustSection" data-component-content="%7B%22elementName%22%3A%22TrustSection%22%7D" />
      <CTASection data-component-id="src/app/homepage/components/HomepageInteractive.tsx:54:6" data-component-path="src/app/homepage/components/HomepageInteractive.tsx" data-component-line="54" data-component-end-line="54" data-component-file="HomepageInteractive.tsx" data-component-name="CTASection" data-component-content="%7B%22elementName%22%3A%22CTASection%22%7D" />
      <ShippingCalculator data-component-id="src/app/homepage/components/HomepageInteractive.tsx:55:6" data-component-path="src/app/homepage/components/HomepageInteractive.tsx" data-component-line="55" data-component-end-line="58" data-component-file="HomepageInteractive.tsx" data-component-name="ShippingCalculator" data-component-content="%7B%22elementName%22%3A%22ShippingCalculator%22%7D"
        isVisible={showCalculator}
        onClose={handleCalculatorClose}
      />
      <TrackingSearch data-component-id="src/app/homepage/components/HomepageInteractive.tsx:59:6" data-component-path="src/app/homepage/components/HomepageInteractive.tsx" data-component-line="59" data-component-end-line="62" data-component-file="HomepageInteractive.tsx" data-component-name="TrackingSearch" data-component-content="%7B%22elementName%22%3A%22TrackingSearch%22%7D"
        isVisible={showTracking}
        onClose={handleTrackingClose}
      />
    </>
  );
};

export default HomepageInteractive;